import axiosApi from "../axiosInstance";
import { getReduxCompany } from "../../helper/sessionHelper";

const getCategoryList = async () => {
    debugger;
    try {
        const response = await axiosApi.get(`/Category/getCategoryList`);
        return response?.data;
    } catch (error) {
        console.log("Error getCategoryList===>:", error);
    }
};
const getCategoryDropdown = async () => {
    try {
        const response = await axiosApi.get(`/Category/GetCategoryDropdown`);
        return response?.data;
    } catch (error) {
        console.log("Error getCategoryDropdown===>:", error);
    }
};

const getIOMCategoryDropdown = async (body) => {
    try {
        body = body || {};
        body.companyId = getReduxCompany()?.companyId || 0;
        const response = await axiosApi.post(`/Category/GetIOMCategoryDropdown`, body);
        return response?.data;
    } catch (error) {
        console.log("Error getIOMCategoryDropdown===>:", error);
    }
};
const getWorkflowCategoryDropdown = async (body) => {
    try {
        body = body || {};
        body.companyId = getReduxCompany()?.companyId || 0;

        const response = await axiosApi.post(`/Category/GetWorkflowCategories`, body);
        return response?.data;
    } catch (error) {
        console.log("Error getWorkflowCategoryDropdown===>:", error);
    }
};

const addCategory = async (body) => {
    try {
        const response = await axiosApi.post(`Category/CreateCategory`, body);
        return response?.data;
    } catch (error) {
        console.log("Error addCategory ===>", error);
    }
};

export const CategoryService = {
    getCategoryList,
    addCategory,
    getIOMCategoryDropdown,
    getCategoryDropdown,
    getWorkflowCategoryDropdown
}